<template>
  <v-modal id="show-case-export-modal" class-name="modal-fullscreen-sm-down w-auto" size="lg" @closed="emit('closed')">
    <modal-header>
      <modal-title>{{ $t("general.shared.customNotes") }}</modal-title>
    </modal-header>

    <modal-body>
      <div class="form-outline">
          <label class="label">
            <span>{{ $t("general.shared.customNotes") }}</span>
          </label>
          <v-html-editor v-model="localNotes" id="the-custom-notes" ref="the-custom-notes" height="400" />
        </div>
    </modal-body>
    <modal-footer class="d-flex justify-content-between mt-4 px-20">
      <v-button class="btn-sm btn-primary">Cancle</v-button>
      <v-button class="btn-sm btn-success" @click="customNotesCase">{{ $t("general.button.save") }}</v-button>
    </modal-footer>
  </v-modal>
</template>

<script setup name="TheCaseCustomNotes">
import VModal from "@/components/vendor/basic/modal/VModal.vue";
import ModalHeader from "@/components/vendor/basic/modal/ModalHeader.vue";
import ModalTitle from "@/components/vendor/basic/modal/ModalTitle.vue";
import ModalBody from "@/components/vendor/basic/modal/ModalBody.vue";
import ModalFooter from "@/components/vendor/basic/modal/ModalFooter.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VHtmlEditor from "@/components/vendor/htmlEditor/VHtmlEditor.vue";
import api from "@/api";
import { useToast } from "vue-toastification";
import { onMounted, ref } from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const toast = useToast();
const emit = defineEmits(["closed", "loadClientCases"]);
const props = defineProps({
  caseId: {
    type: String,
    required: true,
  },
  agency: {
    type: String,
    required: true,
  },
  notes: {
    type: String,
    required: true,
  }
});

const localNotes = ref("");

const customNotesCase = async () => {
  try {
    const payload = {
      invoice_notes: localNotes.value,
    }
    const response = await api.case.caseInvoiceAddNotes(props.agency, props.caseId, payload);
    toast.success(response.message);
    emit("loadClientCases");
    emit("closed");
  } catch (e) {
    console.error(e);
    toast.error(t("general.shared.errorMessage"));
  }
};

onMounted(() => {
  localNotes.value = props.notes;
});
</script>
